import { Component, ChangeDetectionStrategy, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LinkTarget } from '@modules/content-api/adapter/info-section.adapter';
import { take } from 'rxjs/operators';

import { EventsService } from '../../shared/services/events.service';

@Component({
  selector: 'mb-event-registration-section',
  templateUrl: './event-registration-section.component.html',
  styleUrls: ['./event-registration-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventRegistrationSectionComponent implements OnInit {
  @Input() eventId!: string;

  @Output() showSection = new EventEmitter<boolean>();

  public buttonLink!: string;
  public buttonTargetType!: LinkTarget;

  constructor(private eventsService: EventsService) {}

  ngOnInit(): void {
    this.setRegistrationLink();
  }

  private setRegistrationLink(): void {
    this.eventsService
      .getCARLEvent(this.eventId)
      .pipe(take(1))
      .subscribe((event) => {
        if (!!event?.url) {
          this.setButtonLink(event.url, 'self');
          this.showSection.emit(true);
        } else {
          this.showSection.emit(false);
        }
      });
  }

  private setButtonLink(url: string, targetType: LinkTarget): void {
    this.buttonLink = url;
    this.buttonTargetType = targetType;
  }
}
